import { render } from "./MfaTotpSetup.vue?vue&type=template&id=eb4a22a4&scoped=true"
import script from "./MfaTotpSetup.vue?vue&type=script&lang=js"
export * from "./MfaTotpSetup.vue?vue&type=script&lang=js"

import "./MfaTotpSetup.vue?vue&type=style&index=0&id=eb4a22a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4a22a4"],['__file',"src/components/MfaTotpSetup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb4a22a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb4a22a4', __exports__)) {
    api.reload('eb4a22a4', __exports__)
  }
  
  module.hot.accept("./MfaTotpSetup.vue?vue&type=template&id=eb4a22a4&scoped=true", () => {
    api.rerender('eb4a22a4', render)
  })

}


export default __exports__